module.exports = __webpack_public_path__ + "static/foto-peter-4ecb461de4f7f510aa259419e6827156.png";